export default __webpack_public_path__ + "static/media/small-arrow-icon.d70737d6.svg";